import { Fancybox, Panzoom } from '@fancyapps/ui';
import * as bootstrap from 'bootstrap';
// ========================

// oilib.js needs bootstrap to be available on the window object. It uses bootstrap popovers (maybe others, too).
window.bootstrap = bootstrap;

const siteNavHeight = document.getElementById('site-nav').offsetHeight;
const marketHeader = document.querySelector('.market-header');
document.documentElement.style.setProperty('--site-nav-height', siteNavHeight + 'px');
if (marketHeader) {
  const marketHeaderHeight = marketHeader.offsetHeight;
  document.documentElement.style.setProperty('--market-header-height', marketHeaderHeight + 'px');
}

// == model detail scripts
let width = window.innerWidth;
let scrollpos = window.scrollY;
const modelHero = document.querySelector('.model-hero');
const siteNav = document.querySelector('#site-nav');
const subNav = document.querySelector('.model-sub-nav');
const communityToolbar = document.querySelector('.community-toolbar');

if (subNav && width > 767) {
  const offsetSubNavHeight = subNav.offsetHeight;
  document.documentElement.style.setProperty('--scroll-padding-subnav', offsetSubNavHeight + 'px');
  window.addEventListener('scroll', function () {
    const in_viewport = new window.IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          subNav.classList.remove('is-pinned');
          siteNav.classList.remove('is-pinned');
        } else {
          subNav.classList.add('is-pinned');
          siteNav.classList.add('is-pinned');
        }
      },
      {
        root: null,
        threshold: 0.03,
      }
    );
    in_viewport.observe(modelHero);
  });
}
if (communityToolbar) {
  window.addEventListener('scroll', function () {
    scrollpos = window.scrollY;
    if (scrollpos >= 400) {
      communityToolbar.classList.add('community-toolbar-allowed');
    } else {
      communityToolbar.classList.remove('community-toolbar-allowed');
    }
  });
}

const planLinks = document.querySelectorAll('.plan-link');
if (planLinks) {
  planLinks.forEach((planLink) => {
    const planCards = document.querySelectorAll('.plan-tab');
    planLink.addEventListener('click', function (e) {
      planLinks.forEach((e) => {
        e.classList.remove('active');
      });
      var planLinkId = planLink.id;
      planLink.classList.add('active');
      planCards.forEach((planCard) => {
        var planCardId = planCard.getAttribute('data-id');
        if (planLinkId == planCardId) {
          planCard.classList.remove('d-none');
        } else if (planLinkId == 0) {
          planCard.classList.remove('d-none');
        } else {
          planCard.classList.add('d-none');
        }
      });
    });
  });
}
// == video box script
const videoBoxes = document.querySelectorAll('.video-box');
if (videoBoxes) {
  videoBoxes.forEach((videoBox) => {
    const playBtns = videoBox.querySelectorAll('.btn-play');
    const videoCover = videoBox.querySelector('.video-cover');
    const video = videoBox.querySelector('video') || videoBox.querySelector('iframe');
    const videoId = video.id;
    playBtns.forEach((playBtn) => {
      playBtn.addEventListener('click', function (e) {
        videoCover.classList.add('d-none');
        oi.video.play(videoId);
      });
    });
  });
}
// == show more/less location floorplans on location detail page
window.addEventListener("load", (event) => {
  const btnShowMoreLess = document.querySelector('.btn-show-more-less');
  if (btnShowMoreLess) {
    const cards = document.querySelectorAll('.loc-plan-card');
    btnShowMoreLess.addEventListener('click', function () {
      btnShowMoreLess.classList.toggle('active');
      cards.forEach(card => {
        if (card.classList.contains('extra-card')) {
          card.classList.toggle('d-none');
        }
      });
    });
  }
});

// == homepage market show/hide with little animation
const quickFindEl = document.querySelector('.quick-find');
if (quickFindEl) {
  const markets = document.querySelectorAll('.market');
  const showMarket = document.querySelector('.show-markets-button');
  const homepageHero = document.querySelector('.homepage-hero');
  var delay = 100; // 1 second delay for the second element
  showMarket.addEventListener('click', function (e) {
    showMarket.classList.add('d-none');
    markets.forEach(function (element, index) {
      setTimeout(function () {
        if (window.innerHeight < 800) {
          homepageHero.classList.add('homepage-hero-height');
        }
        element.classList.add('show');
      }, index * delay);
    });
    setTimeout(function () {
      markets.forEach(function (element, index) {
        setTimeout(function () {
          element.classList.remove('show');
        }, index * delay);
      });
      showMarket.classList.remove('d-none');
      homepageHero.classList.remove('homepage-hero-height');
    }, 6000);
  });
}
// END homepage market show/hide with little animation
// == add target_blank to external links on footer nav
window.addEventListener('load', function () {
  const siteFooterLinks = document.querySelectorAll('.site-footer ul a');
  siteFooterLinks.forEach((siteFooterLink) => {
    var link = siteFooterLink.href;
    if (/(https):\/\//i.test(link)) {
      siteFooterLink.setAttribute('target', '_blank');
    }
  });
});
// ========================
// ========================
// ========================
// == Trigger Tabs By Hash
var triggerTabList = [].slice.call(document.querySelectorAll('.tab-btn'));
triggerTabList.forEach(function (triggerEl) {
  var tabTrigger = new bootstrap.Tab(triggerEl);
  var hash = '#' + triggerEl.href.split('#')[1];
  var tabBtn = document.querySelector(hash + '-tab');
  triggerEl.addEventListener('click', function (event) {
    event.preventDefault();
    tabBtn.click();
  });
});
// END Trigger Tabs By Hash
// ========================
// ========================
// == Add class to main navbar on scroll
// const navbar = document.querySelector('#site-nav');
// window.addEventListener('scroll', function() {
//     let scroll = window.scrollY;
//     if (scroll > navbar.offsetTop) {
//         navbar.classList.add("scrolled");
//     } else {
//         navbar.classList.remove("scrolled");
//     }
// });
// END scrolled
// ========================
// ========================
// == Panzoom =============
const panzoom = document.querySelector('.panzoom');
const panzoom_reset = document.querySelector('.panzoom-reset');
const panZoomImg = document.querySelector('.panzoom__content');
const fpImgLink = document.querySelectorAll('[data-imgurl]');
if (panzoom != 'undefined' && panzoom != null) {
  const myPanzoom = new Panzoom(panzoom, {
    minScale: 0.5,
    maxScale: 3,
  });
  panzoom_reset.addEventListener('click', function (event) {
    myPanzoom.zoomTo(1);
  });
}
for (const link of fpImgLink) {
  link.addEventListener('click', function () {
    fpImgLink.forEach((e) => {
      e.classList.remove('active-bg');
    });
    link.classList.add('active-bg');
    var imgUrl = link.dataset.imgurl;
    panZoomImg.src = imgUrl;
  });
}
// END Panzoom ============
// ========================
/*
 * FANCYBOX
 *
 * The new Fancybox v4 (non-jQuery) triggers a "done" event for up to three images when
 * the carousel is first initilaized. To avoid triggering 3 image view events on every
 * Fancybox initCarousel action, an imageview event is triggered on the initCarousel
 * event, but "done" events are then ignored for 1 second. After 1 second, image view
 * events will be triggered as typical.
 */
// Tracks fancybox image views.
let fancyboxEventBlock = false;
/** Abstracted event action handler
 * @param {import("@fancyapps/ui").Fancybox} fancybox
 */
const doFancyboxOiEvent = (fancybox) => {
  if (fancybox.options.trigger.dataset.oiEventName) {
    let oi_event_name = fancybox.options.trigger.dataset.oiEventName;
    if ('undefined' != typeof window.dataLayer) {
      window.dataLayer.push({ event: oi_event_name });
    }
    if ('undefined' != typeof window.hfaDataLayer) {
      window.hfaDataLayer.push({ event: oi_event_name });
    }
  }
};
// Bind actions to Fancybox events
Fancybox.bind('[data-fancybox]', {
  placeFocusBack: false,
  on: {
    initCarousel: (fancybox) => {
      if (!fancyboxEventBlock) {
        // Block additional Fancybox events
        fancyboxEventBlock = true;
        // Do Fancybox event
        doFancyboxOiEvent(fancybox);
        // Undo the event block after 1 second.
        setTimeout(() => {
          fancyboxEventBlock = false;
        }, 1000);
      }
    },
    done: (fancybox, slide) => {
      if (!fancyboxEventBlock) {
        // Do Fancybox event
        doFancyboxOiEvent(fancybox);
      }
    },
    destroy: () => {
      // Reset the block on Fancybox close.
      fancyboxEventBlock = false;
    },
  },
});
/* END FANCYBOX */
// This fires the oi.utils function that will wrap all iframes contained in WYSIWYG
// editors with appropriate oi-aspect classes.
window.addEventListener(
  'load',
  function () {
    oi.utils.wrap_oi_aspect();
    // == page_about_us nav/tab active class
    const team = document.querySelector('.team');
    if (team) {
      const navItems = team.querySelectorAll('.nav-item');
      const tabs = team.querySelectorAll('.tab-pane');
      navItems.forEach(function (navItem, i) {
        if (i == 0) {
          navItem.querySelector('button').classList.add('active');
        }
      });
      tabs.forEach(function (tab, i) {
        const classes = ['active', 'show'];
        if (i == 0) {
          tab.classList.add(...classes);
        }
      });
    }
  },
  false
);
window.addEventListener('oi.loaded.form.paradeofhomesform', function () {
  oi.loaded.form.paradeofhomesform.addSuccessAction = function (response) {
    if (response.data.data.redirect_url) {
      window.location.href = response.data.data.redirect_url;
    }
  };
});
